// extracted by mini-css-extract-plugin
module.exports = {"value":"value--4aSgW"};